import styled from "styled-components";

const getPlanBackground = (planName) => {
  if (!planName)
    return "linear-gradient(45deg, rgba(223, 209, 197, 0.60) 0%, rgba(255, 246, 235, 0.60) 100%)";

  const lowerCasePlanName = planName.toLowerCase();

  if (lowerCasePlanName.includes("plus")) {
    return "linear-gradient(180deg, #F3F7FA 0%, #E4ECF5 100%)";
  } else if (lowerCasePlanName.includes("core")) {
    return "linear-gradient(180deg, #F6FAF3 0%, #E8F5E4 100%)";
  } else if (lowerCasePlanName.includes("free")) {
    return "linear-gradient(180deg, var(--colors-gray-light-mode-50, #FAFAFA) 0%, var(--colors-gray-light-mode-100, #F5F5F5) 100%)";
  } else if (
    lowerCasePlanName.includes("pro") ||
    lowerCasePlanName.includes("premium")
  ) {
    return "linear-gradient(45deg, rgba(223, 209, 197, 0.60) 0%, rgba(255, 246, 235, 0.60) 100%)";
  }

  return "linear-gradient(45deg, rgba(223, 209, 197, 0.60) 0%, rgba(255, 246, 235, 0.60) 100%)";
};

export const PurchasePlanCardContainer = styled.div`
  .content-wrapper {
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    a {
      text-decoration: none;
      font-weight: 500;
      font-size: 14px;
      color: ${({ theme }) => theme.button.bg.primary};

      svg {
        margin-left: 5px;
      }
    }

    h2 {
      font-size: 25px;
      margin-bottom: 0;
    }

    p {
      font-size: 13px;
      color: ${({ theme }) => theme.modal.color.primary};
    }

    h4 {
      font-size: 16px;
    }

    ul {
      list-style: none;
      padding-left: 0;

      li {
        font-size: 15px;
        display: flex;
        align-items: baseline;

        svg {
          margin-right: 6px;
        }

        .tag {
          padding: 0 5px;
          border-radius: 8px;
          margin-right: 6px;
          line-height: 1.5rem;
        }
      }
    }
  }

  .restore-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 25px;

    .amount-wrapper {
      font-size: 28px;
      font-weight: 600;
      color: ${({ theme }) => theme.global.extraInfo.font.color};
      margin-bottom: 0;

      .duration {
        font-size: 12px;
        font-weight: 400;
        vertical-align: middle;
        display: inline-block;
        margin-left: 4px;
      }
    }
    .benefit {
      font-weight: 400;
      font-size: 12px;
      line-height: 25px;
      margin-top: 8px;
      text-align: center;
    }
  }

  .trial-details {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0px 0 40px 0;

    .sub-text {
      font-size: 13px;
      color: ${({ theme }) => theme.modal.color.primary};
    }
  }

  button {
    width: 100%;
    margin-top: 15px;
  }

  .disableButton {
    background-color: ${({ theme }) => theme.button.bg.tertiary} !important;
  }

  .due-date {
    font-weight: 500;
    font-size: 15px;
    color: ${({ theme }) => theme.button.bg.primary};
    margin-top: 85px;
  }

  .helptext {
    font-size: 12px;
    color: ${({ theme }) => theme.modal.color.primary};
    text-align: center;
  }

  .price-wrapper {
    h2 {
      font-size: 15px;
    }

    .monthly-wrapper {
      display: flex;
      align-items: center;
    }

    .yearly-wrapper {
      display: flex;
      align-items: center;

      div {
        padding: 6px 10px;
        font-size: 14px;
        font-weight: 500;
        background-color: ${({ theme }) => theme.button.bg.primary};
      }
    }

    .current-plan-label {
      font-size: 12px;
      color: ${({ theme }) => theme.button.bg.primary};
    }

    .form-check {
      margin-bottom: 20px;

      .form-check-input {
        margin-top: 8px;
      }

      .form-check-label {
        font-size: 20px;
        font-weight: 500;

        .price {
          font-size: 15px;
          color: ${({ theme }) => theme.modal.color.primary};
        }
      }
    }

    &.placeholder-wrapper {
      .title {
        width: 100px;
        height: 24px;
      }

      .radio-button {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        margin-right: 10px;
        display: inline-block;
      }

      .radio-label {
        width: 100px;
        height: 20px;
        border-radius: 4px;
        display: inline-block;
      }

      .badge-label {
        width: 60px;
        height: 28px;
        border-radius: 16px;
      }

      .due-date-label {
        width: 120px;
        height: 18px;
        border-radius: 4px;
      }

      .change-premium-btn {
        width: 100px;
        height: 20px;
        border-radius: 4px;
      }

      .helptext-label {
        width: 120px;
        height: 16px;
        border-radius: 4px;
        display: inline-block;
      }
    }
  }

  .current-wrapper {
    padding: 10px 40px;

    .current-plan {
      margin-bottom: 1.5rem;

      h2 {
        text-transform: capitalize;
        font-size: 20px;
        font-weight: 500;
      }
    }

    .details {
      font-size: 13px;
      margin-bottom: 4rem;
    }

    button.cancel-premium-btn {
      background-color: #ff3f3f;
    }
    button.change-premium-btn {
      background-color: transparent;
      text-align: right;
      .loader {
        justify-content: right;
      }
    }
  }

  .current-subscription-wrapper {
    border-radius: 16px;
    position: relative;
    overflow: visible;

    .plan-name-wrapper {
      background: ${({ $planName }) => getPlanBackground($planName)};
      border-radius: 12px;
      padding: 20px;
      margin: 12px 12px 0px;
    }

    .subscription-header {
      margin-bottom: 20px;

      .plan-title-section {
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;

        .plan-name {
          font-size: 16px;
          font-weight: 500;
          font-family: "Geist", sans-serif;
          color: rgba(52, 48, 48, 0.25);
          margin: 0;
        }

        .interval-badge,
        > div {
          background-color: #ffffff !important;
          color: #6b6b6b !important;
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 14px !important;
          font-weight: 500;
          border: 1px solid #e0e0e0;
          margin-left: 0;
        }
      }
    }

    .price-display {
      .price-amount {
        font-size: 32px;
        font-weight: 500;
        letter-spacing: -2px;
        background: linear-gradient(
          45deg,
          var(--colors-gray-light-mode-800, #252b37) 0%,
          var(--colors-gray-light-mode-600, #535862) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .price-currency {
        font-size: 18px;
        font-weight: 400;
        color: #6b6b6b;
        margin-left: 8px;
        font-family: "Geist", sans-serif;
      }
    }
    .info-cards-row-wrapper {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      align-items: center;
      gap: 24px;
      padding: 8px 20px 20px;
      .info-cards-row {
        display: flex;
        gap: 40px;
        align-items: flex-start;
        flex-wrap: wrap;

        .info-card {
          display: flex;
          gap: 8px;
          align-items: flex-start;
          flex-direction: column;
          .info-card-content {
            display: flex;
            align-items: baseline;
            gap: 12px;

            .info-icon {
              svg {
                width: 20px;
                height: 20px;
                color: #4a4a4a;
              }
            }
          }
        }

        .info-content {
          flex: 1;

          .info-label {
            font-size: 14px;
            font-weight: 400;
            color: rgba(10, 13, 18, 0.6);
            font-family: "Geist", sans-serif;
          }
        }

        .info-value {
          font-size: 14px;
          font-weight: 400;
          color: rgba(10, 13, 18, 0.9);
          font-family: "Geist", sans-serif;
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: wrap;

          .discount-badge {
            border-radius: 9999px;
            border: 1px solid #bdd8ff;
            background: #eff5ff;
            color: #1841dd;
            font-size: 12px;
            font-family: "Geist", sans-serif;
            font-weight: 500;
            padding: 4px 12px;
          }

          .discount-text {
            color: rgba(10, 13, 18, 0.9);
            font-family: "Geist", sans-serif;
            font-weight: 400;
            font-size: 14px;
          }
        }
      }

      .update-plan-btn {
        background-color: #ffffff;
        color: rgba(10, 13, 18, 0.7);
        border: 2px solid #e0e0e0;
        border-radius: 12px;
        padding: 10px 14px;
        font-weight: 650;
        font-family: "Geist", sans-serif;
        font-size: 14px;
        transition: all 0.3s ease;
        white-space: nowrap;
        margin-top: 8px;
        width: auto;

        &:hover {
          background-color: #f5f5f5;
          border-color: #c0c0c0;
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }
      }
    }

    .free-plan-wrapper {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: 8px 20px 20px;
      gap: 32px;
      .free-plan-text {
        font-size: 14px;
        font-weight: 400;
        color: rgba(10, 13, 18, 0.7);
        font-family: "Geist", sans-serif;
      }
    }

    .upcoming-plan-info {
      background-color: #fff8e6;
      border-left: 4px solid #ffc107;
      padding: 16px 20px;
      border-radius: 8px;
      font-size: 14px;
      color: #6b6b6b;
      line-height: 1.6;
      margin-bottom: 20px;
    }

    button.cancel-premium-btn {
      background: linear-gradient(135deg, #ff4444 0%, #cc0000 100%);
      color: #ffffff;
      border: none;
      border-radius: 12px;
      padding: 14px 28px;
      font-weight: 600;
      font-size: 16px;
      transition: all 0.3s ease;
      width: auto;
      display: inline-block;

      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 6px 16px rgba(255, 68, 68, 0.3);
      }
    }
  }

  .pro-plan-label {
    padding-bottom: 25px;
  }

  @media (max-width: 768px) {
    .current-wrapper {
      padding: 30px 10px;
    }
    .price-wrapper {
      .trial-details {
        margin-top: 0;

        svg {
          width: 46px;
        }
      }

      .helptext {
        margin-bottom: 20px;
      }
    }

    .current-wrapper .current-plan h2 {
      margin-bottom: 5px;
    }

    .current-subscription-wrapper {
      padding: 24px;

      .plan-card-information {
        padding: 20px;
      }

      .subscription-header .plan-title-section {
        .plan-name {
          font-size: 24px;
          padding: 0;
        }

        .interval-badge {
          font-size: 12px;
          padding: 4px 12px;
        }
      }

      .price-display {
        .price-amount {
          font-size: 42px;
        }

        .price-currency {
          font-size: 16px;
        }
      }

      .info-cards-row-wrapper {
        flex-direction: column;
        align-items: baseline;
      }

      .info-cards-row {
        flex-direction: column;
        gap: 20px !important;
        align-items: center;

        .info-card {
          min-width: 100%;

          .info-icon {
            svg {
              width: 20px;
              height: 20px;
            }
          }

          .info-content {
            .info-label {
              font-size: 13px;
            }

            .info-value {
              font-size: 14px;

              .discount-badge {
                font-size: 12px;
                padding: 3px 10px;
              }
            }
          }
        }
      }

      .update-plan-btn {
        width: 100% !important;
      }

      .free-plan-wrapper {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
      }

      button.cancel-premium-btn {
        width: 100%;
        padding: 12px 24px;
        font-size: 15px;
      }
    }
  }

  @media (max-width: 425px) {
    .current-wrapper {
      padding: 30px 12px;
    }

    .current-subscription-wrapper {
      padding: 20px;

      .subscription-header .plan-title-section {
        .plan-name {
          font-size: 20px;
        }
      }

      .price-display {
        .price-amount {
          font-size: 36px;
        }

        .price-currency {
          font-size: 14px;
        }
      }

      .info-cards-row {
        .info-card {
          gap: 12px;
        }
      }
    }
  }

  @media (max-width: 576px) {
    .price-wrapper {
      .form-check {
        margin-right: 0.25rem;
        margin-bottom: 0;
      }
      .form-check-label {
        margin-bottom: 0;
        font-size: 1rem;
      }
    }
  }

  @media (width: 768px) {
    .price-wrapper .col-md-6 {
      flex: 0 0 100%;
      max-width: 100%;
    }
  }
`;

export const BillingBackgroundIcon = styled.div`
  position: absolute;
  right: 0;
  top: ${({ $isFreePlan }) => ($isFreePlan ? "14px" : "23px")};
  mix-blend-mode: luminosity;
  filter: drop-shadow(0 0 60px rgba(179, 173, 166, 0.25));

  @media (max-width: 768px) {
    display: none;
  }
`;
